import { apiGetBookingTableList } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    api_request: 'bookingManagement/api_request',
    api_error: 'bookingManagement/api_error',
    api_success: 'bookingManagement/api_success',
    api_update: 'bookingManagement/api_update',
}

// count state 必須是 Object
const state = {
    status: '',
    apiName: ''
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_STATUS: (state) => {
        return state.status
    },
    GET_API_NAME: (state) => {
        return state.api_name
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBookingTableList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.api_request);
            apiGetBookingTableList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.api_success);
                    commit(types.booking_list, res.data.result);
                    resolve(res.data.result)
                }else{
                    commit(types.api_error);
                }
            })
            .catch(err => {
                commit(types.api_error);
                reject(err)
            })
        })
    },
    setApiStatus( {commit}, type ) {
        return new Promise((resolve, reject) => {
            if( type == 'update' ){
                commit(types.api_update);
            }else if( type == 'success' ){
                commit(types.api_success);
            }
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.api_request](state){
        state.status = 'loading'
    },
    [types.api_error](state){
        state.status = 'error'
    },
    [types.api_success](state){
        state.status = 'success'
    },
    [types.api_update](state){
        state.status = 'update'
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/bookingManagement.js